import { DomHelpers } from '@salesperformanceint/e4shared';
import React from 'react';

export const PanelSlider = ({ children, showIndex, zoomToStart, recalc, onSlideStart, onSlideComplete }) => {
    const slider = React.useRef(null);

    children = children.reduce((a, c) => (!c ? a : Array.isArray(c) ? a.concat(c) : a.concat([c])), []);

    React.useEffect(() => {
        const resizeHandler = () => DomHelpers.arrangeTiles('sliderItem');
        setTimeout(() => resizeHandler(), 250);
        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);

    React.useEffect(() => {
        DomHelpers.arrangeTiles('sliderItem');
    }, [recalc]);

    React.useEffect(() => {
        if (slider.current) {
            const left = (showIndex || 0) * -100;
            const increment = left === 0 && zoomToStart ? 100 : 5;
            onSlideStart && onSlideStart();
            const inter = setInterval(() => {
                if (slider.current) {
                    const current = slider.current.style.left ? parseInt(slider.current.style.left.replace('%', ''), 10) : 0;

                    if (current === left) {
                        clearInterval(inter);
                        onSlideComplete && onSlideComplete();
                    } else {
                        const move = current > left ? increment * -1 : increment;
                        slider.current.style.left = `${current + move}%`;
                    }
                }
            }, 10);
        }
    }, [showIndex]);

    return (
        <div className="sliderWrapper">
            <div
                data-testid="slider-container"
                className="sliderContainer"
                ref={slider}
                style={{ width: `${100 * children?.length}%` }}
            >
                {children.map((child, i) => {
                    return (
                        <div key={`slider-${i}`} className="sliderItem" style={{ width: `${100 / children?.length}%` }}>
                            {child}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default PanelSlider;
